// ----------------------------------------------------------------------------------
// Scrollen
// ----------------------------------------------------------------------------------

$(window).scroll(function() {


    scrollDistance = $(window).scrollTop();

    if (scrollDistance>0) {
        $('body').removeClass('scrolled-top').addClass('scrolled');
    }
    else {
        $('body').removeClass('scrolled').addClass('scrolled-top');
    }



    //  if($('.parallax-item').isOnScreen())
    // {
    //      $('.parallax-item.near').css({transform: 'rotate(' + parseInt((360-(scrollDistance/3))) + 'deg)'})
    //      $('.parallax-item.medium').css({transform: 'rotate(' + parseInt((360-(scrollDistance/8))) + 'deg)'})
    //      $('.parallax-item.far').css({transform: 'rotate(' + parseInt((360-(scrollDistance/16))) + 'deg)'})
    //  }

    // ----------------------------------------------------------------------------------
    // Counter
    // ----------------------------------------------------------------------------------

    if ($(".counter").length) {
        //var counterUp = window.counterUp["default"]; // import counterUp from "counterup2"

        var $counters = $(".count-up");


        $('.count-up').each(function(ignore,counter) {
            if ($(this).isOnScreen()) {
                if (!$(this).hasClass('counted')) {
                    $(this).addClass('counted');
                    /* Start counting, do this on DOM ready or with Waypoints. */
                    // counterUp(counter, {
                    //    duration: 1000,
                    //    delay: 16,
                    //    lang: 'de-DE'
                    // });
                    counterInit($(this),1500);
//
                }
            }
        })




    }
    // var scrollDistance = $(window).scrollTop();
    //
    // windowheight= $(window).height();
    // innerheightLeft= $('#main-column-left .inner').height();
    // innerheightRight= $('#main-column-right .inner').height();
    // leftcolwidth=$('#main-column-left').width();
    // viewport=windowheight-$('#top').height();
    //
    //
    //
    // if (innerheightRight<viewport || innerheightLeft>=innerheightRight || (innerheightLeft+100)>=viewport) {
    //     $('#main-column-left .inner').removeClass('fixed').addClass('scrollable');
    //     $('#main-column-left .inner').attr('style','');
    // }
    // else
    // {
    //     $('#main-column-left .inner').removeClass('scrollable').addClass('fixed');
    //
    //
    //     offset=scrollDistance-($('#main-column-right').height()-viewport);
    //
    //
    //     if ($('#main-column-left .inner.fixed').css('position')=='fixed') {
    //
    //         $('#main-column-left .inner').css('width',leftcolwidth+'px');
    //
    //
    //         if (scrollDistance) {
    //             $('#main-column-left .inner.fixed').css('transform', 'translate(0,-' + offset + 'px)');
    //         }
    //         else {
    //             $('#main-column-left .inner.fixed').css('transform', 'translate(0,' + 0 + 'px)');
    //         }
    //     }
    //
    //     // Assign active class to nav links while scolling
    //     $('.frame-type-menu_section a').each(function (i) {
    //
    //         var href = $(this).attr('href');
    //
    //         var anchor = href.split('#');
    //
    //         if ($('#' + anchor[1]).position().top <= scrollDistance + 210) {
    //
    //             $('.frame-type-menu_section a').removeClass('active');
    //             $('.frame-type-menu_section a').eq(i).addClass('active');
    //
    //             $('#section-menu-pager li').removeClass('active');
    //             $('#section-menu-pager li').eq(i).addClass('active');
    //
    //         }
    //     });
    //
    //
    //     if ((scrollDistance+windowheight)==$(document).height()) {
    //         e=$('.frame-type-menu_section a').length-1;
    //         activateAnchorMenu(e);
    //     }
    //
    // }

    // ----------------------------------------------------------------------------------
    // Videosegment - Autoplay
    // ----------------------------------------------------------------------------------


    if ($(".video-embed.autoplay").length && bootstrapSize()!='xs') {
        $('.video-embed.autoplay').each(function() {

            if ($(this).isOnScreen()) {



                var video = $(this).parent().find('video')[0];

                if (video.paused) {
                    $(this).find('.play').fadeOut(500);
                    video.play();
                } else {

                }
            }
            else {
                var video = $(this).parent().find('video')[0];

                if (video.paused) {

                } else {
                    video.pause();
                    $(this).find('.play').fadeIn(500);
                }
            }

        });
    }





}).scroll();